import { render } from "./MuteCustomer.vue?vue&type=template&id=6d716152&scoped=true&lang=pug"
import script from "./MuteCustomer.vue?vue&type=script&lang=js"
export * from "./MuteCustomer.vue?vue&type=script&lang=js"

import "./MuteCustomer.vue?vue&type=style&index=0&id=6d716152&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d716152"]])

export default __exports__